import React, { useEffect, useRef, useState } from 'react'
import { Doughnut } from 'react-chartjs-2';
import { FormatRupiah } from '@arismun/format-rupiah';

const Keluar = (props) => {
    const kredit = props.data;
    const bgColor = []

    useEffect(() => {
        console.log(kredit)
    }, []);

    const backgroundColor = () => {
        const backgroundcolor = [];
        for (let i = 0; i < kredit.length; i++) {
            const r = Math.floor(Math.random() * 255);
            const g = Math.floor(Math.random() * 255);
            const b = Math.floor(Math.random() * 255);
            backgroundcolor.push('rgba(' + r + ', ' + g + ', ' + b + ', 0.5');
            bgColor.push('rgba(' + r + ', ' + g + ', ' + b + ', 0.5');
        }
        return backgroundcolor;
    }

    const getStyle = (color) => {
        return ({
            width: '30px',
            height: '15px',
            marginTop: '5px',
            marginRight: '10px',
            backgroundColor: color
        })
    }



    const getOrCreateLegendList = (chart, id) => {
        const legendContainer = document.getElementById(id);
        let listContainer = legendContainer.querySelector('ul');

        if (!listContainer) {
            listContainer = document.createElement('ul');
            // listContainer.style.display = 'flex';
            // listContainer.style.flexDirection = 'row';
            listContainer.style.margin = 0;
            listContainer.style.padding = 0;

            legendContainer.appendChild(listContainer);
        }

        return listContainer;
    };

    const htmlLegendPlugin = {
        id: "htmlLegend",
        afterUpdate(chart, args, options) {
            const ul = getOrCreateLegendList(chart, options.containerID);

            // Remove old legend items
            while (ul.firstChild) {
                ul.firstChild.remove();
            }

            // Reuse the built-in legendItems generator
            const items = chart.options.plugins.legend.labels.generateLabels(chart);

            items.forEach(item => {
                const li = document.createElement('li');
                li.classList.add('is-clearfix')
                li.classList.add('is-clickable')

                li.onclick = () => {
                    const { type } = chart.config;
                    if (type === 'pie' || type === 'doughnut') {
                        // Pie and doughnut charts only have a single dataset and visibility is per item
                        chart.toggleDataVisibility(item.index);
                    } else {
                        chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                    }
                    chart.update();
                };

                // Color box
                const boxSpan = document.createElement('div');
                boxSpan.style.background = item.fillStyle;
                boxSpan.style.borderColor = item.strokeStyle;
                boxSpan.style.borderWidth = item.lineWidth + 'px';
                boxSpan.style.height = '20px';
                boxSpan.style.marginRight = '10px';
                boxSpan.style.width = '20px';
                boxSpan.classList.add('is-pulled-left')

                const label = kredit.find(credit=>
                    credit.category === item.text
                )

                // Text
                const textContainer = document.createElement('div');
                textContainer.style.color = item.fontColor;
                textContainer.style.textDecoration = item.hidden ? 'line-through' : '';
                textContainer.classList.add('is-pulled-left');

                const text = document.createTextNode(item.text);
                textContainer.appendChild(text);

                // Amount
                const amountContainer = document.createElement('div');
                amountContainer.style.color = item.fontColor;
                amountContainer.style.textDecoration = item.hidden ? 'line-through' : '';
                amountContainer.classList.add('is-pulled-right')

                const amount = document.createTextNode(rupiah(label.amount));
                amountContainer.appendChild(amount);

                li.appendChild(boxSpan);
                li.appendChild(textContainer);
                li.appendChild(amountContainer);
                ul.appendChild(li);
            });
        }
    };

    const rupiah = (number) => {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        }).format(number);
    }

    return (
        <div className='card'>
            <header className='card-header'>
                <p className='card-header-title is-size-7'>Keluar</p>
            </header>
            <div className='card-content'>
                <div>
                    <Doughnut
                        data={{
                            labels: kredit.map((item) => item.category),
                            datasets: [
                                {
                                    // label: "kredit (pengeluaran)",
                                    data: kredit.map((item) => item.amount),
                                    backgroundColor: backgroundColor(),
                                }
                            ]
                        }}
                        options={{
                            plugins: {
                                htmlLegend: {
                                    // ID of the container to put the legend in
                                    containerID: 'legend-container',
                                },
                                legend: {
                                    display: false
                                }
                            }
                        }}
                        redraw={true}
                        plugins={[htmlLegendPlugin]}
                    />
                </div>
                <div id='legend-container' className='mt-5'></div>
            </div>
        </div>
    )
}

export default Keluar
